import { GeoJSON } from 'react-leaflet';
import React, { useEffect, useContext, useState } from "react";
import axios from 'axios';
import { SystemErrorContext } from './SystemError';

const CaltopoFeaturesLayer = ({ id }) => {
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [geoJsonData, setGeoJsonData] = useState({
    type: "FeatureCollection",
    features: []
  });

  useEffect(() => {
    let unmounted = false;
    const source = axios.CancelToken.source();

    const getCaltopoData = async () => {
      try {
        const response = await axios.get(`/incident/api/incident/${id}/caltopo/`, {
          cancelToken: source.token
        });
        setGeoJsonData(response.data.caltopo_data);
      } catch (error) {
        if (!unmounted) {
          setShowSystemError(true);
        }
      }
    };
    getCaltopoData();

    return () => {
      unmounted = true;
      source.cancel(); // cancel any pending requests on unmount
    };
  }, [id, setShowSystemError]);

  const styleFeature = (feature) => ({
    color: feature.properties.stroke || '#3388ff',
    fillColor: feature.properties.fill || '#3388ff',
    weight: feature.properties['stroke-width'] || 2,
    fillOpacity: feature.properties['fill-opacity'] || 0.4,
    opacity: feature.properties['stroke-opacity'] || 1
  });

  return (
    <GeoJSON key={geoJsonData.features.length} data={geoJsonData} style={styleFeature} />
  );
};

export default CaltopoFeaturesLayer;
